import React, { useState, useEffect } from 'react'; // Adicione useEffect
import { InputMask } from 'primereact/inputmask';
import { useNotification } from 'context/NotificationContext';

const validarCRM = crm => {
  if (!crm || crm.trim() === '') return false;
  const crmLimpo = crm.trim();
  // Valida: 6 dígitos + / + 2 letras (maiúsculas ou minúsculas)
  return /^\d{6}\/[a-zA-Z]{2}$/.test(crmLimpo);
};

const InputCRM = ({ value, onChange, className, placeholder, id, name, tooltip, disabled }) => {
  const notify = useNotification();
  const [crm, setCRM] = useState(value);

  // Sincroniza o estado local com o value recebido via props
  useEffect(() => {
    setCRM(value);
  }, [value]);

  const handleBlur = e => {
    // Valida se o CRM está preenchido e é válido
    if (!crm || crm.trim() === '' || !validarCRM(crm)) {
      notify({
        type: "error",
        message: `CRM inválido. Formato esperado: 123456/SP`
      });
      // Limpa o campo mas permite sair
      setCRM('');
      if (onChange) {
        onChange({ target: { name: name || 'crm', value: '' } });
      }
    } else if (onChange) {
      // Se válido, garante que o valor seja enviado
      onChange({ target: { name: name || 'crm', value: crm } });
    }
  };

  const handleChange = e => {
    const newValue = e.value;
    setCRM(newValue);
    // Sempre envia o valor para o componente pai
    if (onChange) {
      onChange({ target: { name: name || 'crm', value: newValue } });
    }
  };

  return (
    <InputMask
      id={id}
      value={crm || ''} // Garante que o valor não seja undefined/null
      onChange={handleChange}
      onBlur={handleBlur}
      className={`form-control ${className}`}
      mask="999999/aa"
      placeholder={placeholder}
      tooltip={tooltip}
      disabled={disabled}
      autoClear={false} // Impede que o InputMask limpe valores inválidos
    />
  );
};

export default InputCRM;